<template>
  <form class="form form-horizontal" v-on:submit="submitForm">
    <modal
      :is-hidden="isHidden"
      :is-open="isOpen"
      :title="$t('Projects.add')"
      ref="modal"
      v-on:clickclose="closeDialog"
      :alert="alertTitle"
      :alert-style="alertStyle"
      :alert-text="alertText"
      :alert-icon="alertIcon"
      alert-dismissable
      :size="dialogSize"
      v-on:dismissalert="closeAlert"
      v-on:close="reset"
    >
      <div v-if="hintText" class="alert alert-warning" v-html="$t(hintText)"></div>

      <div v-if="!projectNameValid && form.name" class="alert alert-info">
        {{$root.getLabelText(projectNameValidationDescription)}}
      </div>

      <div :class="`input-group input-group-lg ${projectNameValid ? 'valid' : 'invalid'}`">
        <input
                type="text"
                name="name"
                class="form-control"
                :placeholder="$root.getLabelText(placeholderText)"
                :disabled="form.type == null"
                v-model="form.name"
                @input="validateName()"
                @keypress="checkInput($event)"
        />
      </div>

      <field v-for="field of customFields"
        :key="field.id"
        :name="field.id"
        :placeholder="$root.getLabelText(field.label)"
        :type="field.type"
        fieldClass="col-xs-12"
        size="lg"
        v-model="form.form[field.id]"
        v-on:input="handleFormInput"
      />


      <template v-if="hasMultipleWorkflows">
        <div class="projecttype">{{ $t('Projects.projectType') }}</div>

        <div class="row flex-row">
          <div :class="tileClass" v-for="(workflowType, workflowTypeId) in workflowTypes" v-if="workflowType.visibility === true">
            <cardbanner v-if="workflowType.disabled"
                        color="grey"
                        :icon="workflowType.icon"
                        :icon-prefix="workflowType.iconPrefix"
                        :image="workflowType.image"
                        tile
            >
              <span v-html="$t(workflowType.titleHtml || workflowType.title)"></span> <div class="desc" v-html="$t(workflowType.description)"></div>
            </cardbanner>
            <cardbanner v-else
                        :color="workflowType.color"
                        :icon="workflowType.icon"
                        :icon-prefix="workflowType.iconPrefix"
                        :image="workflowType.image"
                        tile
                        :active="form.type === workflowTypeId"
                        v-on:click="setProjectType(workflowTypeId)"
            >
              <span v-html="$t(workflowType.titleHtml || workflowType.title)"></span> <div class="desc" v-html="$t(workflowType.description)"></div>
            </cardbanner>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button type="button" class="btn btn-sm btn-default" v-on:click="closeDialog">{{ $t('Action.close') }}</button>
        <button type="submit" class="btn btn-sm btn-success" v-if="workflowCount > 0" :disabled="activeRequest || !projectNameValid"><i v-if="activeRequest" class="fa fa-spinner fa-spin"></i> {{ $t('Action.add') }}</button>
      </template>
    </modal>
  </form>
</template>

<script>

var view = require('../view.js'),
    viewData = {
      workflowGroupId: null,
      isHidden: true,
      isOpen: false,
      activeRequest: false,
      alertTitle: '',
      alertText: '',
      alertStyle: '',
      alertIcon: '',
      workflowTypes: [],
      workflowCount: 0,
      hasMultipleWorkflows: true,
      form: {
        name: '',
        type: 'stl',
        form: {}
      },
      projectNameValid: null,
    },
    resetData = Object.assign({}, viewData);

export default view(viewData, {
  computed: {
    hintText() {
      return this.$root.getLocaleProperty('hintNewProject');
    },
    customFields() {
      return this.$root.projectDialogForm || [];
    },
    tileClass() {
      var c = 0;

      for (var id in this.workflowTypes) {
        if (this.workflowTypes.hasOwnProperty(id)) {
          if (this.workflowTypes[id].visibility === true) {
            c++;
          }
        }
      }

      if (c === 0)
        return '';

      if (c > 9) {
        return 'mbottom-10 col-xs-4 horizontal-tile';
      }

      if (c > 6) {
        return 'mbottom-10 col-xs-6 horizontal-tile';
      }

      c = c <= 3 ? 12 / c : c === 4 ? 6 : c === 5 ? 4 : c === 6 ? 4 : c === 11 ? 2 : 3;

      return 'mbottom-10 col-xs-' + c + ' col-sm-' + c + ' col-md-' + c + ' col-lg-' + c;
    },
    dialogSize() {
      var c = 0;

      for (var id in this.workflowTypes) {
        if (this.workflowTypes.hasOwnProperty(id)) {
          if (this.workflowTypes[id].visibility === true) {
            c++;
          }
        }
      }

      return c > 6 ? 'lg' : 'md';
    },
    selectedWorkflow() {
      return (this.form.type && viewData.workflowTypes[this.form.type]) || {};
    },
    placeholderText() {
      const {
        placeholder = 'Projects.projectName',
      } = this.selectedWorkflow.titleFormat || {};
      return placeholder;
    },
    projectNameValidationDescription() {
      const {
        placeholder,
        validatorDescription = placeholder || 'Projects.projectNameInvalid',
      } = this.selectedWorkflow.titleFormat || {};
      return validatorDescription;
    }
  },
  mounted() {
    this.reset();
  },
  methods: {
    reset() {
      for (var i in resetData) {
        if (resetData.hasOwnProperty(i)) {
          if (typeof resetData[i] != 'object' && i != 'isHidden' && i != 'isOpen') {
            viewData[i] = resetData[i];
          }
        }
      }

      viewData.form.name = '';
      viewData.form.description = '';
      this.customFields.forEach(_ => {
        if (_.id) {
          viewData.form.form[_.id] = _.value || ''
        }
      });

      const {workflows = []} = this.$root.currentUser;
      viewData.workflowTypes = Object.fromEntries(
          Object.entries(this.getWorkflowTypes())
              .filter(([wf]) => workflows.length === 0 || workflows.indexOf(wf) >= 0));
      viewData.workflowCount = Object.keys(viewData.workflowTypes).length;
      viewData.hasMultipleWorkflows = viewData.workflowCount > 1;

      viewData.projectNameValid = null;

      if (viewData.workflowCount === 0) {
        this.alertTitle = 'There are no workflows for this workflow group';

      }

      // The first visible project type is pre-selected
      for (var id in this.workflowTypes) {
        if (this.workflowTypes.hasOwnProperty(id)) {
          if (this.workflowTypes[id].visibility === true) {
            this.form.type = id;
            break;
          }
        }
      }
    },
    submitForm(evt) {
      evt.preventDefault();

      if (this.form.name == '') {
        this.alertTitle = this.$t('Projects.errorNoName');
        return;
      }

      this.closeAlert();
      this.activeRequest = true;
      this.$http.post(this.$root.url + 'project/', this.form).then(
        function(res) {
          this.activeRequest = false;
          this.$emit('projectcreated', res.data.result);
          this.closeDialog();
        }.bind(this),
        function(res) {
          this.activeRequest = false;
          this.alertTitle = this.$t('Projects.errorCreate');
        }.bind(this));
    },
    closeDialog() {
      this.$refs.modal.close(this);
    },
    openDialog(workflowGroupId) {
      this.workflowGroupId = typeof workflowGroupId === 'undefined' ? null : workflowGroupId;
      this.reset();
      this.$refs.modal.open(this);
    },
    closeAlert() {
      this.alertTitle = '';
      this.alertText  = '';
      this.alertStyle = '';
      this.alertIcon  = '';
    },
    setProjectType(workflowType) {
      this.form.type = workflowType;
    },
    getWorkflowTypes() {
      if (typeof this.$root.workflowTypes === 'undefined')
        return {};

      if (!this.workflowGroupId)
        return this.$root.workflowTypes;

      let workflowTypes = {};
      Object.keys(this.$root.workflowTypes).forEach(key => {
        if (this.$root.workflowTypes[key].visibility !== true){
          return;
        }
        if (
          (typeof this.$root.workflowTypes[key].workflowGroup === 'undefined')
          || (this.$root.workflowTypes[key].workflowGroup === null)
          || (typeof this.$root.workflowTypes[key].workflowGroup === 'string' && this.$root.workflowTypes[key].workflowGroup === this.workflowGroupId)
          || (this.$root.workflowTypes[key].workflowGroup instanceof Array && this.$root.workflowTypes[key].workflowGroup.includes(this.workflowGroupId))
        ) {
          workflowTypes[key] = this.$root.workflowTypes[key];
        }
      });

      return workflowTypes;
    },
    validateName() {
      let {
        formatter = '^.$',
        validator = '^.*$',
      } = this.selectedWorkflow.titleFormat || {};

      formatter = new RegExp(formatter);
      validator = new RegExp(validator);

      this.form.name = (this.form.name || '').split('').filter(x => formatter.test(x)).join('');
      viewData.projectNameValid = validator.test(this.form.name);
    },
    checkInput({key, target}) {
      let {
        formatter = '^.$',
      } = this.selectedWorkflow.titleFormat || {};

      formatter = new RegExp(formatter);
      if (!formatter.test(`${key}`)) {
        target = target.parentNode;
        target.classList.remove('invalid-key');
        setTimeout(() => target.classList.add('invalid-key'));
      }
    },
    handleFormInput(value, field) {
      viewData.form.form[field.name] = value;
      this.$forceUpdate();
    },
  }
});
</script>

<style>
  .flex-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .flex-row > * {
    display: flex;
    flex: 1;
  }

  .flex-row > .col-xs-8 {
    min-width: calc(100% * 8/12);
  }
  .flex-row > .col-xs-6 {
    min-width: calc(100% * 6/12);
  }
  .flex-row > .col-xs-4 {
    min-width: calc(100% * 4/12);
  }
  .flex-row > .col-xs-3 {
    min-width: calc(100% * 3/12);
  }

  .desc {
    display: block;
    margin-top: 8px;
    font-size: 70%;
  }

  .input-group.invalid {
    border-color: red;
  }

  .input-group.invalid-key {
    animation: shake 1s linear;
  }

  @keyframes shake {
    10%, 90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%, 80% {
      transform: translate3d(2px, 0, 0);
    }

    30%, 50%, 70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%, 60% {
      transform: translate3d(4px, 0, 0);
    }
  }

  .horizontal-tile .card-body {
    display: flex;
  }

  .horizontal-tile .icon {
    flex: .25;
  }

  .horizontal-tile .card.card-tile .card-body .content {
    align-items: flex-start;
    justify-content: flex-start;
  }
</style>
